<div fxLayoutAlign="center center" style="margin-top: 1em;">
  <div fxFlex="80" fxLayoutAlign="center center" fxLayoutGap="5%">
    <img src="/assets/i/contract.jpg" fxFlex="50">
    <div fxFlex="50">
      <h2>Contract Law</h2>
      <p>Whether it's employment agreements, intellectual property transfers, residential or commercial leases, or business transactions, we are able to help you understand, draft, and negotiate contracts that protect you and your interests. We pride ourselves on tailoring contracts to individual circumstances using plain language as much as possible. With our experience as civil litigators we can spot which provisions are most likely to cause problems and either rewrite them or plan strategies to minimize your risk.</p>
    </div>
  </div>
</div>
